export default __webpack_public_path__ + "static/media/manual19.f73799ac.png";